class SingleProduct {
	init() {
		this.SingleProduct();
	}
  SingleProduct() {
    const tables = document.querySelectorAll('table');
    tables.forEach((table)=>{
      const numbers = table.querySelectorAll('tr td:first-child');
      numbers.forEach((number) => {
        number.classList.add('js-target-' + number.textContent);
      });
    });

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const paramsProductNum = params.get('product_num');
    const scrollTarget = document.querySelector(".js-target-" + paramsProductNum);
    const scrollTargetRect = scrollTarget?.getBoundingClientRect();
    if(scrollTargetRect) {
      const scrollTargetRectTop = scrollTargetRect.top + window.pageYOffset - 100;
      window.scrollTo({
        top: scrollTargetRectTop,
      });
    }
  }
}

export default SingleProduct;
